function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 7.29388C0 11.4347 7.49689 20 7.49689 20C7.49689 20 15 11.3245 15 7.29388C15 3.26327 11.5942 0 7.49689 0C3.40166 0 0 3.1551 0 7.29388ZM1.00003 7.30985C0.98984 3.88516 3.93984 1.0101 7.51325 1.00004C11.0867 0.987958 13.998 3.88918 14 7.29777C14.0041 10.7084 7.51325 18.5 7.51325 18.5C7.51325 18.5 1.01021 10.7345 1.00003 7.30985ZM10 6.5C10 7.88019 8.88019 9 7.5 9C6.11981 9 5 7.88019 5 6.5C5 5.11981 6.11981 4 7.5 4C8.88019 4 10 5.11981 10 6.5ZM6 6.5C6 5.67111 6.67111 5 7.5 5C8.32889 5 9 5.67111 9 6.5C9 7.32889 8.32889 8 7.5 8C6.67111 8 6 7.32889 6 6.5Z",
  fill: "#424B5A"
});

var SvgAddressEnter = function SvgAddressEnter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddressEnter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/address-enter.90e34782.svg";
export { ForwardRef as ReactComponent };